<div class="card mb-2" *ngIf="hasConfig">
  <div class="card-body p-2">

    <div class="d-flex align-items-center justify-content-between gap-2 mb-1">
      <h5 class="fw-bold mb-0">{{ title }}</h5>
      <button type="button" class="btn btn-primary btn-sm" (click)="addRow()">
        <i class="fa fa-plus"></i> {{ buttonLabel }}
      </button>
    </div>

    <app-uic-form #rowsForm *ngIf="showRows"
      [gFormUIC]="uicForm"
      [gFormGroup]="rowsFormGroup"
      [enableMultipleForms]="true"
      [addFormButtonLabel]="buttonLabel"
      [showAddMultiFormButton]="false"
      [isFormModal]="false"
      [openForm]="false"
      [showModalHeader]="false"
      [showFooter]="false">
    </app-uic-form>

  </div>
</div>
